'use strict';

exports.__esModule = true;
exports.QuMapAbstract = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _leaflet = require('leaflet');

var _leaflet2 = _interopRequireDefault(_leaflet);

var _reactLeaflet = require('react-leaflet');

var _markers = require('./markers/markers');

var _markers2 = _interopRequireDefault(_markers);

var _quMapAbstract = require('./qu-map-abstract/qu-map-abstract');

var _quMapAbstract2 = _interopRequireDefault(_quMapAbstract);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _uniqBy = require('lodash/uniqBy');

var _uniqBy2 = _interopRequireDefault(_uniqBy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QuMap = function (_Component) {
  _inherits(QuMap, _Component);

  function QuMap() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, QuMap);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = QuMap.__proto__ || Object.getPrototypeOf(QuMap)).call.apply(_ref, [this].concat(args))), _this), _this.onEachFeature = function (feature, layer) {
      var _feature$properties = feature.properties,
          properties = _feature$properties === undefined ? {} : _feature$properties;


      if (feature.geometry.type === 'LineString') {
        layer.options.color = properties.style && properties.style.color || _this.props.lineColor;
        layer.options.opacity = _this.props.lineOpacity;
      }
    }, _this.pointToLayer = function (feature, position) {
      var permanentTooltip = _this.props.permanentTooltip;
      var _feature$properties2 = feature.properties,
          properties = _feature$properties2 === undefined ? {} : _feature$properties2;

      var html = null;

      if (properties.type === 'courier' || properties.transportMode) {
        html = _markers2.default.quiqee(properties.styles, properties.markerText, properties.transportMode);
      } else {
        html = _markers2.default.waypoint(properties.styles, properties.markerText, properties.markerLabel, properties.badge);
      }

      var icon = _leaflet2.default.divIcon({
        className: 'qu-map-marker var-' + properties.type,
        iconAnchor: [0, 24],
        popupAnchor: [0, -42],
        html: html
      });

      var marker = new _leaflet2.default.marker(position, { icon: icon });

      var offsetVertical = {
        popup: -17,
        tooltip: -70
      };

      var offsetHorizontal = 2;

      var showTooltip = properties.onHover ? properties && properties.name && properties.showTooltip : properties && properties.name;
      if (showTooltip) {
        marker.bindTooltip('<div><p>' + properties.name.replace(' ', '&nbsp;') + '</p></div>', {
          permanent: permanentTooltip,
          direction: 'top',
          opacity: 1,
          offset: _leaflet2.default.point(offsetHorizontal, offsetVertical.tooltip)
        });
      }

      if (properties.popupHtml) {
        marker.bindPopup(properties.popupHtml, {
          offset: _leaflet2.default.point(offsetHorizontal, offsetVertical.popup)
        });
      }

      if (typeof properties.onClick === 'function') {
        marker.on('click', properties.onClick);
      }

      if (typeof properties.onHover === 'function') {
        marker.on('mouseover', properties.onHover);
      }

      return marker;
    }, _this.withBounds = function () {
      var geoJson = _this.props.geoJson;
      var withBounds = _this.props.withBounds;


      if (!geoJson) return undefined;

      geoJson = Array.isArray(geoJson) ? geoJson : [geoJson];

      if (withBounds && geoJson && geoJson[0]) {
        var coords = geoJson[0].features.reduce(function (accumulator, currentValue) {
          if (typeof currentValue.geometry.coordinates[0] === 'number') {
            accumulator.push([currentValue.geometry.coordinates[1], currentValue.geometry.coordinates[0]]);
          }
          return accumulator;
        }, []);

        var boundsCoords = coords.map(function (bound) {
          return _leaflet2.default.latLng(bound);
        });
        var uniqueCoords = (0, _uniqBy2.default)(boundsCoords, function (_bound) {
          return _bound.lat || _bound.lng;
        });

        if (uniqueCoords.length > 1) {
          return uniqueCoords;
        }

        return undefined;
      }

      return undefined;
    }, _this.boundsOrCenter = function () {
      var _this$props = _this.props,
          center = _this$props.center,
          boundsOptions = _this$props.boundsOptions;
      var geoJson = _this.props.geoJson;


      geoJson = Array.isArray(geoJson) ? _extends({}, geoJson) : geoJson;

      var isOneMarker = geoJson && geoJson.features && geoJson.features.length === 1;
      var boundsOrCenter = {};

      if (!isOneMarker) {
        boundsOrCenter = {
          bounds: _this.withBounds(),
          boundsOptions: boundsOptions,
          center: center
        };
      } else {
        boundsOrCenter = {
          bounds: undefined,
          center: [geoJson.features[0].geometry.coordinates[1], geoJson.features[0].geometry.coordinates[0]]
        };
      }

      return boundsOrCenter;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(QuMap, [{
    key: 'renderGeoJson',
    value: function renderGeoJson() {
      var _this2 = this;

      var geoJson = this.props.geoJson;


      if (!geoJson) return '';

      geoJson = Array.isArray(geoJson) ? geoJson : [geoJson];
      return geoJson.map(function (geo) {
        if (!geo) return '';
        return _react2.default.createElement(_reactLeaflet.GeoJSON, {
          data: geo,
          style: geo.style,
          pointToLayer: _this2.pointToLayer,
          key: 'force_remount_' + Math.random(),
          onEachFeature: _this2.onEachFeature
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          animate = _props.animate,
          zoom = _props.zoom,
          maxZoom = _props.maxZoom,
          tileUrl = _props.tileUrl,
          className = _props.className,
          center = _props.center,
          props = _objectWithoutProperties(_props, ['animate', 'zoom', 'maxZoom', 'tileUrl', 'className', 'center']);

      return _react2.default.createElement(
        _reactLeaflet.Map,
        _extends({
          animate: animate,
          className: (0, _classnames2.default)(['qu-map', className]),
          zoom: zoom,
          maxZoom: maxZoom
        }, this.boundsOrCenter(), props),
        _react2.default.createElement(_reactLeaflet.TileLayer, { showOnSelector: false, url: tileUrl }),
        this.props.geoJson && this.renderGeoJson(),
        this.props.children
      );
    }
  }]);

  return QuMap;
}(_react.Component);

QuMap.propTypes = {
  animate: _propTypes2.default.bool,
  withBounds: _propTypes2.default.bool,
  permanentTooltip: _propTypes2.default.bool,
  boundsOptions: _propTypes2.default.object,
  center: _propTypes2.default.array,
  children: _propTypes2.default.node,
  geoJson: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  lineColor: _propTypes2.default.string,
  lineOpacity: _propTypes2.default.number,
  tileUrl: _propTypes2.default.string,
  zoom: _propTypes2.default.number,
  maxZoom: _propTypes2.default.number,
  className: _propTypes2.default.string
};

QuMap.defaultProps = {
  animate: true,
  withBounds: true,
  permanentTooltip: false,
  boundsOptions: { padding: [60, 60] },
  center: [51.5285582, -0.2416805],
  lineColor: '#583470',
  lineOpacity: 1,
  tileUrl: 'https://maptiles.quiqup.com/styles/klokantech-basic/{z}/{x}/{y}.png',
  zoom: 12,
  maxZoom: 20,
  className: ''
};

exports.QuMapAbstract = _quMapAbstract2.default;
exports.default = QuMap;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/qu-react-sdk/lib/components/qu-map/index.js
// module id = 717
// module chunks = 0